// Category & DNA helpers shared across the atlas.

export const CATEGORY_COLORS = {
  classic: "#E8E1D1",
  citrus: "#F2C94C",
  floral: "#D8B4E2",
  spice: "#D35400",
  coastal: "#5B7C99",
  herbal: "#87A96B",
  fruity: "#A23B72",
  earthy: "#6E5C54",
  luxury: "#D4AF37",
  experimental: "#8A2BE2",
};

export const DNA_AXES = [
  { key: "juniper", label: "Juniper" },
  { key: "citrus", label: "Citrus" },
  { key: "floral", label: "Floral" },
  { key: "spice", label: "Spice" },
  { key: "herbal", label: "Herbal" },
  { key: "fruit", label: "Fruit" },
  { key: "earthy", label: "Earthy" },
  { key: "coastal", label: "Coastal" },
  { key: "sweetness", label: "Sweetness" },
  { key: "complexity", label: "Complexity" },
];

export function getCategoryColor(cat) {
  return CATEGORY_COLORS[cat] || CATEGORY_COLORS.classic;
}

export function topDnaAxes(dna, n = 4) {
  return [...DNA_AXES]
    .map((a) => ({ ...a, value: dna[a.key] || 0 }))
    .sort((a, b) => b.value - a.value)
    .slice(0, n);
}

export const COUNTRY_FLAG = {
  India: "IN", UK: "GB", Scotland: "SCT", Japan: "JP",
  Belgium: "BE", Greece: "GR", Spain: "ES", France: "FR",
  Italy: "IT", Germany: "DE",
};
